import { Box, useClassNames } from '@factorialco/deprecated-design-system'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { Moment } from 'moment'
import moment from 'moment'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { gridColumnsVar } from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { ScheduleRecordValuesType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'
import { getBackgroundColor } from 'modules/project_management/components/Schedule/Body/ScheduleItem/utils'

import SubRowCell from './SubRowCell'

interface ISubRowProps {
  days: Moment[]
  records?: ScheduleRecordValuesType[]
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
}

const SubRow = ({ days, records = [], openSidepanel }: ISubRowProps) => {
  const cx = useClassNames(stylesRefs)

  const generateRecordsWithSpans = () => {
    const result = []
    let i = 0

    while (i < days.length) {
      const currentDay = days[i]

      const record = records.find((r) =>
        currentDay?.isBetween(moment(r.startDate), moment(r.endDate), 'day', '[]')
      )

      if (record) {
        const span = days
          .slice(i)
          .findIndex(
            (day) => !day?.isBetween(moment(record.startDate), moment(record.endDate), 'day', '[]')
          )

        const actualSpan = span === -1 ? days.length - i : span
        result.push({ span: actualSpan, record })
        i += actualSpan
      } else {
        result.push({ span: 1 })
        i++
      }
    }

    return result
  }

  const cells = generateRecordsWithSpans()
  const totalCells = days.length

  return (
    <Box
      className={cx('scheduleItemDateContainer')}
      style={assignInlineVars({
        [gridColumnsVar]: totalCells.toString(),
      })}
    >
      {cells.map((value, index) => (
        <SubRowCell
          key={index}
          span={value.span}
          record={value.record}
          openSidepanel={openSidepanel}
        />
      ))}
      <Box
        className={cx('gridOverlay')}
        style={assignInlineVars({
          [gridColumnsVar]: totalCells.toString(),
        })}
      >
        {Array.from({ length: totalCells }).map((_, i) => (
          <Box key={i} background={getBackgroundColor(i, days)} className={cx('gridLine')} />
        ))}
      </Box>
    </Box>
  )
}

export default SubRow
